module.exports = __webpack_public_path__ + "static/hero_en-912747a4df26b06096c7a85b683d34dd.png";